export default {
  actions: {
    confirm: 'Review'
  },
  breadcrumbLaborCore: 'Labor Core',
  columns: {
    action: 'Action',
    dependentDeductionNextYearShort: 'Dependent (Next Year)',
    dependentDeductionShort: 'Dependent',
    documentProgress: 'Document progress',
    dueDate: 'Due date',
    housingLoanShort: 'Housing loan',
    insurancePremiumShort: 'Insurance',
    lastUpdatedAt: 'Last updated',
    previousEmployerShort: 'Previous employer',
    separateHandling: 'Separate handling',
    separateHandlingHelp: 'Shows documents handled individually outside the system, such as on paper.',
    spouseDeductionShort: 'Spouse',
    status: 'Status',
    target: 'Target'
  },
  documentStatus: {
    confirmed: 'Confirmed',
    eligibilityPending: 'Pending eligibility',
    notApplicable: 'Not applicable',
    notSubmitted: 'Not submitted',
    returned: 'Returned',
    submitted: 'Submitted'
  },
  documentTabs: {
    all: 'All',
    dependentDeduction: 'Dependent',
    dependentDeductionNextYear: 'Dependent (Next Year)',
    housingLoan: 'Housing loan',
    insurancePremium: 'Insurance',
    previousEmployer: 'Previous employer',
    spouseDeduction: 'Spouse'
  },
  documentTabsSeparator: ', ',
  downloadCsv: 'Download CSV',
  drawer: {
    close: 'Close',
    documents: {
      formLoadError: 'Failed to load declaration details.',
      formLoading: 'Loading declaration details…',
      formUnavailable: 'Declaration details are unavailable.',
      separateHandlingFlag: 'Mark for separate handling'
    },
    loadError: 'Failed to load instance detail.',
    openInstance: 'Open instance detail',
    overview: {
      affiliation: 'Department'
    },
    title: 'Year-end adjustment'
  },
  dueDateRelative: {
    overdue: 'Overdue'
  },
  emptyCell: '—',
  export: {
    completedDescription: 'The CSV file has been downloaded.',
    completedTitle: 'Export completed',
    downloadFailedTitle: 'Download failed',
    downloadPrevious: 'Download previous file',
    failedDescription: 'Failed to export the CSV file. Please try again.',
    failedTitle: 'Export failed',
    parseFailedDescription: 'The export was stopped because some declaration data could not be read. Please review the affected documents: {{failures}}',
    parseFailureEntry: '{{name}} ({{document}})',
    parseFailureOverflow: ', and {{overflowCount}} more',
    parseFailureUnknownPerson: 'Unknown person',
    startedDescription: 'Generating the CSV file. It will download automatically when ready.',
    startedTitle: 'Export started',
    statusCheckFailedDescription: 'Could not check the export status. Please try exporting again.'
  },
  listLoadError: 'Failed to load the list.',
  overallStatus: {
    awaitingReview: 'Awaiting review',
    completed: 'Completed',
    pendingAction: 'Pending action',
    returned: 'Returned'
  },
  pageTitle: 'Year-end adjustment',
  retry: 'Retry',
  searchPlaceholder: 'Search by name',
  statusFilter: 'Status'
};